/**
 * @flow
 */

export const ROUTE = Object.freeze({

  INDEX: '/',
  SIGN_IN: '/dboard/login',
  SIGN_UP: '/dboard/register',
  FORGOT_PASSWORD: '/dboard/forgot-password',
  NOT_FOUND: '/dboard/not-found',

  DASHBOARD_OVERVIEW: '/dboard/overview',
  DASHBOARD_MAP_VIEW: '/dboard/mapview',
  DASHBOARD_CHART: '/dboard/chart',
  DASHBOARD_LIST: '/dboard/list',
  DASHBOARD_NOTI: '/dboard/notifications',
  DASHBOARD_PATIENTS_LIST: '/dboard/patientslist',

  REPORT_SUMMARY: '/dboard/reports/summary',
  REPORT_DAILY: '/dboard/reports/daily',
  REPORT_MONTHLY: '/dboard/reports/monthly',

  SETTINGS_COMPANY: '/dboard/settings/companies',
  SETTINGS_BRANCH: '/dboard/settings/branches',
  SETTINGS_GROUP: '/dboard/settings/groups',
  SETTINGS_DEVICE: '/dboard/settings/devices',
  SETTINGS_CONTROLLER: '/dboard/settings/controllers',
  SETTINGS_USER: '/dboard/settings/users',
  SETTINGS_CONNECT: '/dboard/settings/connect',
  SETTINGS_DEVICE_TYPE: '/dboard/settings/device-types',
  SETTINGS_PROFILE: '/dboard/settings/profile',

  LOGS_NOTIFICATIONS: '/dboard/logs/notifications',
  LOGS_ACTIVITIES: '/dboard/logs/activities',
  LOGS_LOGINS: '/dboard/logs/logins',
  LOGS_BAD_DATA: '/dboard/logs/bad-data',
  LOGS_ERRORS: '/dboard/logs/error',
  LOGS_DEMO_REQUESTS: '/dboard/logs/demo-requests',

});

export const chartColorArray = [
  //'#FF1744',
  '#127BF4',
  //'#F57C00',
  '#2EA433',
  '#FFEA00',
  //'#6200EA',
  '#35C5F0',
  '#9B9B9B',
  '#19F288',
  '#302D35',
  '#B388FF',
  '#F806E5',
  '#B4DC86',
  '#18FFFF',
  '#4AF907',
  '#0097A7',
  '#7A82ED',
  //'#B74150',
  '#A3B24E',
  '#EA80FC',
];
